import styled from '@emotion/styled';

const NavSelectValue = styled('span')`
  width: 70%;
  height: 100%;
  color: ${({ theme }) => theme.text.medium};
  display: flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: 14px;
  padding-left: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default NavSelectValue;
